/**
 * Asks the user to confirm something through the application's shared
 * confirmation modal (AppConfirmDialog, mounted once at the root).
 *
 * Resolves true when they accept and false when they decline or dismiss, so
 * a caller can await the answer rather than passing callbacks. Passing
 * `rejectLabel: null` drops the decline button, which turns the modal into
 * an acknowledgement for something the user cannot act on.
 */
export default {
    methods: {
        confirm(options) {
            // A bare string is accepted so that passing one cannot silently
            // produce a dialog with buttons and an empty body.
            const {
                message,
                hint = null,
                header = null,
                acceptLabel = 'Yes',
                rejectLabel = 'Cancel',
                danger = false,
            } = typeof options === 'string' ? { message: options } : options

            return new Promise((resolve) => {
                this.$confirm.require({
                    header,
                    message,
                    hint,
                    acceptLabel,
                    rejectLabel,
                    danger,
                    accept: () => resolve(true),
                    reject: () => resolve(false),
                    onHide: () => resolve(false),
                })
            })
        },
    },
}
